import { useEffect } from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import { useCloneLeaseMutation } from '../../../utils/queries';

function CopyLease({ lease, terminateActiveAction }: LeaseActionProps) {
  const cloneLeaseMutation = useCloneLeaseMutation();

  useEffect(() => {
    cloneLeaseMutation.mutate({ postData: { leaseId: lease.id as unknown as number } });
    terminateActiveAction();
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, []);

  return null;
}

export default CopyLease;
